import { get } from './axios'
import { ReceiptData } from 'src/models/Receipt'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getReceipt
 */

type GetReceiptParams = {
  userId: number
  year: number
  month: number
}

export const getReceipt = async ({ userId, ...rest }: GetReceiptParams) => {
  return await get<ReceiptData>(`/v1/users/${userId}/receipts`, rest)
}

/**
 * getReceiptDates
 */

type GetReceiptDatesParams = {
  userId: number
}

type GetReceiptDatesResponseData = {
  dates: string[]
}

export const getReceiptDates = async ({ userId }: GetReceiptDatesParams) => {
  const data = await get<GetReceiptDatesResponseData>(`/v1/users/${userId}/receipts/dates`)
  return data.dates
}
